export default {
  students: [],
  selectedStudent: "",
  studentLearning: [],
  get_singlestudent: [],
  studentInfo: {},
};
